module.exports = __webpack_public_path__ + "img/SC6-Future_income_needs_3.9f8205f5.png";